






































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';
import { ContractPaginator, ContractsState } from '@/stores/contracts/types';
import Paginator from '@/components/Paginator.vue';
import { PaginatorEvent } from '@/types';
import { ContractStatusColor } from '@/enums';

const namespace: string = 'contracts';

@Component({
    components: {
        Paginator,
    },
})
export default class ContractsView extends Vue {
    @State('contracts') contracts!: ContractsState;
    @Action('get', { namespace }) getContracts: any;
    @Getter('contracts', { namespace }) contractsPaginator!: ContractPaginator;

    fields: any = [
        {
            label: 'Party',
            key: 'party.name',
        },
        {
            key: 'signed',
            label: 'Signed date',
        },
        {
            key: 'status',
            label: 'Status',
        },
        {
            key: 'actions',
            label: 'Actions',
        },
    ];

    currentPage: any = 1;
    perPage: any = 10;
    search: string = '';
    canceled: boolean = false;

    @Watch('search')
    @Watch('canceled')
    onPropertyChanged() {
        this.updateContracts();
    }

    mounted() {
        this.currentPage = this.$route.query.page || 1;
        this.perPage = this.$route.query.per_page || 10;
        this.updateContracts();
    }

    updateContracts() {
        this.getContracts({
            page: this.currentPage,
            perPage: this.perPage,
            search: this.search,
            canceled: this.canceled,
        });
    }

    updatePaginate(paginatorObject: PaginatorEvent) {
        this.perPage = paginatorObject.perPage;
        this.currentPage = paginatorObject.currentPage;
        this.updateContracts();
    }

    get contractsData() {
        return this.contractsPaginator.data;
    }

    get contractsPages() {
        return this.contractsPaginator.metadata;
    }

    rowStatus(item: any, type: any) {
        return item ? 'table-' + ContractStatusColor[item.status as 'NEW'|'SIGNED'|'CANCELED'] : '';
    }
}
